import { Observable, Subject } from "rxjs";
import { FlexSdkError } from "../error";

export default class ErrorReporter extends Object {
    readonly #telemetryErrorSubject: Subject<FlexSdkError>;

    constructor() {
        super();
        this.#telemetryErrorSubject = new Subject<FlexSdkError>();
    }

    public get telemetryErrorStream(): Observable<FlexSdkError> {
        return this.#telemetryErrorSubject.asObservable();
    }

    publishTelemetryError(e: FlexSdkError): void {
        this.#telemetryErrorSubject.next(e);
    }
}
